// alterado - revisado

import React from 'react'

import FormControlLabel from '@material-ui/core/FormControlLabel'

import Checkbox from '@material-ui/core/Checkbox'

import Typography from '@material-ui/core/Typography'

import {
    COLOR,
} from '../../business-const/Color/Color'

import {
    FONTSIZE,
    FONTWEIGHT,
} from '../../business-const/Style/Style'

export const CheckboxPadrao = ( props ) => {

    const { label, ...rest } = props

    return (
        <FormControlLabel
            className="mt-1 mb-1 min-w-288"

            control={
                <Checkbox
                    size="small"
                />
            }

            label={
                <Typography
                    style={{
                        fontSize: FONTSIZE().CheckBox,
                        fontWeight: FONTWEIGHT().CheckBox,
                        color: COLOR().checkBox,
                    }}
                >
                    {label}
                </Typography>
            }

            {...rest}
        />
    )
}